import { apiSlice } from "../apiSlice";
import {
  CreateSetMenuRequest,
  CustomMenuItem,
  SetMenu,
  UpdateSetMenuRequest,
} from "../setMenuSlice";

export interface MenuApiResponse {
  setMenuList: SetMenu[];
}

export interface CustomMenuListResponse {
  customMenuList: CustomMenuItem[];
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const setMenuService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createSetMenu: builder.mutation<string, CreateSetMenuRequest>({
      query: (requestData) => ({
        url: `https://adminhttps-createsetmenu-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),

    getMenuListByRestaurantId: builder.query<MenuApiResponse, string>({
      query: (restaurantId) => ({
        url: `https://adminhttps-getsetmenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),

    deleteSetMenu: builder.mutation<
      void,
      { restaurantId: string; setMenuId: string }
    >({
      query: (requestData) => ({
        url: `https://adminhttps-deletesetmenu-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "DELETE",
        body: requestData,
      }),
    }),

    updateSetMenu: builder.mutation<string, UpdateSetMenuRequest>({
      query: (requestData) => ({
        url: `https://adminhttps-updatesetmenu-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "PUT",
        body: requestData,
        responseHandler: (response) => response.text(),
      }),
    }),

    // =============================== //
    fetchCustomMenuList: builder.query<CustomMenuListResponse, string>({
      query: (restaurantId) => ({
        url: `https://adminhttps-getcustommenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app/?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),
    // get menu item list
    getMenuListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getmenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),
    // get  single menu item  listt  from database
    getMenuSingleListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getmenuitemsbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),
    // get  set menu item  listt  from database
    getMenuSetListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getsetmenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),
    // get Custom Menu item from databae
    getMenuCustomListFromCustomerSite: builder.query<any, string>({
      query: (restaurantId) => ({
        url: `https://customersitehttps-getcustommenulistbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app?restaurantId=${restaurantId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateSetMenuMutation,
  useGetMenuListByRestaurantIdQuery,
  useLazyGetMenuListByRestaurantIdQuery,
  useDeleteSetMenuMutation,
  useUpdateSetMenuMutation,
  useLazyFetchCustomMenuListQuery,
  useGetMenuListFromCustomerSiteQuery,
  useGetMenuSingleListFromCustomerSiteQuery,
  useGetMenuSetListFromCustomerSiteQuery,
  useGetMenuCustomListFromCustomerSiteQuery

} = setMenuService;
